import { Injectable } from '@angular/core';
import { LOCALSTORAGE } from 'app/core/constants/constants';
import Crypto from 'crypto-js';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class LocalstorageService {
  encryptData(data: any): string {
    return Crypto.AES.encrypt(
      JSON.stringify(data),
      Crypto.enc.Utf8.parse(environment.cryptoSecret),
      {
        mode: Crypto.mode.ECB,
      },
    ).toString();
  }

  decryptData(data: any): any {
    try {
      const bytes = Crypto.AES.decrypt(data, Crypto.enc.Utf8.parse(environment.cryptoSecret), {
        mode: Crypto.mode.ECB,
      });
      return JSON.parse(bytes.toString(Crypto.enc.Utf8));
    } catch (error) {
      return null;
    }
  }

  setItem(key: LOCALSTORAGE, data: any) {
    localStorage.setItem(this.encryptData(key), this.encryptData(data));
  }

  getItem(key: LOCALSTORAGE) {
    return this.decryptData(localStorage.getItem(this.encryptData(key)));
  }
  /**
   *
   * @param key Key to remove from localStorage
   */
  removeItem(key: LOCALSTORAGE) {
    localStorage.removeItem(this.encryptData(key));
  }

  clear() {
    localStorage.clear();
  }

  getFullStorage() {
    const storage = { local: localStorage, session: sessionStorage };
    const local: any = {};
    Object.keys({ ...storage.local, ...storage.session }).map((item: string) => {
      local[this.decryptData(item)] = this.decryptData(
        localStorage.getItem(item) || sessionStorage.getItem(item),
      );
    });
  }
}
